import { useEffect, useRef } from 'react';
import { SetSessionStorageData, GetSessionStorageData } from '../../../Utilities/Helpers/Helper';
import { AUTHENTICATION, GLOBAL_CONSTANTS } from '../../../Constants/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../../../Redux/Reducer/Reducer';
import { useTranslation } from 'react-i18next';
import "./GTranslator.scss";

const GTranslator = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const language: any = useSelector((state: any) => state.languageReducer.language);
  const selectRef = useRef<HTMLSelectElement | null>(null);

  useEffect(() => {
    
    const storedLang = GetSessionStorageData(AUTHENTICATION.SHARED.LANGUAGE_SWICTH);
    if (storedLang) {
      dispatch(setLanguage(storedLang));
      i18n.changeLanguage(storedLang === 'Arabic' ? 'ar' : 'en');
    }

    
    document.documentElement.setAttribute('translate', 'no');
    document.documentElement.lang = i18n.language;
  }, []);

  useEffect(() => {
    
    if (selectRef.current) {
      const select = selectRef.current;
      const optionAr = select.querySelector('option[value="ar"]');
      const optionEn = select.querySelector('option[value="en"]');

      if (optionAr) optionAr.textContent = 'العربية';
      if (optionEn) optionEn.textContent = 'English';

      
      select.setAttribute('translate', 'no');
      Array.from(select.options).forEach(opt => opt.setAttribute('translate', 'no'));
    }
  }, [language]);

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = e.target.value;
    if (selected === 'ar') {
      SetSessionStorageData(AUTHENTICATION.SHARED.LANGUAGE_SWICTH, 'Arabic');
      dispatch(setLanguage('Arabic'));
      i18n.changeLanguage('ar');
    } else {
      SetSessionStorageData(AUTHENTICATION.SHARED.LANGUAGE_SWICTH, 'English');
      dispatch(setLanguage('English'));
      i18n.changeLanguage('en');
    }
  };

  return (
    <div className="language-switcher" translate="no">
      <select
        ref={selectRef}
        value={language === 'Arabic' ? 'ar' : 'en'}
        onChange={handleLanguageChange}
        style={{ direction: language === 'Arabic' ? 'rtl' : 'ltr' }}
        translate="no"
      >
        <option value="en" style={{ fontSize: '14px', fontFamily: 'Manrope600' }}>English</option>
        <option value="ar" style={{ fontSize: '14px', fontFamily: 'Manrope600' }}>العربية</option>
      </select>
    </div>
  );
};

export default GTranslator;
